import * as React from 'react';
const EpistassiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px;stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M85 55v5.39c0 4.59 10.74 18.47 20.67 29.95 6.8 7.86 14.33 13.12 14.33 17.16 0 6.34-6.22 10.77-9.33 10.77h-5.33c-2.67 0-8 4.04-8 6.73"
      className="prefix__cls-2"
    />
    <path
      d="M82.67 104.81S80 109.13 80 112.89s3.78 6.73 6.67 6.73 13.33-5.38 17.33-5.38c.24 0 2.36.08 2.36.42 0 .24-2.01.47-2.24.52-1.12.21-4.03.41-5.61.41"
      className="prefix__cls-2"
    />
    <path
      d="M106.67 123.33c1.7 6.05 6.67 9.5 6.67 15.25 0 3.54-2.98 6.42-6.67 6.42s-6.67-2.87-6.67-6.42c0-5.75 4.97-9.2 6.67-15.25"
      style={{
        stroke: secondaryColor || '#ffcf38',
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
      }}
    />
  </svg>
);
export default EpistassiIcon;
